import { createStructuredSelector } from 'reselect'

const licenses = ({ licenses }) => licenses.getIn(['licensesList'], [])
const loading = ({ licenses }) => licenses.getIn(['loading'], false)

export default createStructuredSelector({
  loading,
  licenses
})
